"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBMIT_POLL = exports.RESET = exports.FETCH_POLL_DETAILS = exports.ERROR_RESET = void 0;
const RESET = 'poll/RESET';
exports.RESET = RESET;
const FETCH_POLL_DETAILS = 'poll/FETCH_POLL_DETAILS';
exports.FETCH_POLL_DETAILS = FETCH_POLL_DETAILS;
const ERROR_RESET = 'poll/ERROR_RESET';
exports.ERROR_RESET = ERROR_RESET;
const SUBMIT_POLL = 'poll/SUBMIT_POLL';
exports.SUBMIT_POLL = SUBMIT_POLL;
//# sourceMappingURL=types.js.map